import React from 'react'
import { StyledCreateQuestionBox, StyledQuestionBoxHeader } from '../../../styles'
import { useDispatch } from 'react-redux'
import CreateQuestionCardDropDownMenu from '../CreateQuestionCardWrapper/CreateQuestionCardDropDownMenu'
import { grey } from '../../../../../colors'
import { getEditableQuestion } from '../../../../../store/slices/SurveyTemplateSlice/selectors'
import { deleteQuestionFromSection, type ISurveySection, setSelectedQuestion } from '../../../../../store/slices/SurveyTemplateSlice'
import { Box } from '@mui/material'
import { notification } from '../../../../../components/Notifications'
import { type Question } from '../../../types'

interface FollowUpWrapperProps {
  children: JSX.Element
  questionNumber?: number
  questionData: Question
  section: ISurveySection
  isAdminAddedQuestion?: boolean
}

const FollowUpWrapper: React.FC<FollowUpWrapperProps> = ({ children, questionNumber, questionData, section, isAdminAddedQuestion }): JSX.Element => {
  const dispatch = useDispatch()
  const editableQuestion = getEditableQuestion()
  const { questionIndex } = editableQuestion ?? {}

  const handleDelete = (): void => {
    if (questionData?.branchingFilters && questionData?.branchingFilters?.length > 0) {
      notification('This Question contains a Branch section. You cannot delete this section', { variant: 'error' })
      return
    }
    if (editableQuestion?.question) {
      dispatch(deleteQuestionFromSection({ surveySectionId: section.surveySectionId, questionIndex }))
      return
    }
    dispatch(setSelectedQuestion(null))
  }

  return (
    <StyledCreateQuestionBox>
      <StyledQuestionBoxHeader sx={{ color: grey[700], fontWeight: 500 }} >
        Question {questionNumber}
        <Box display='flex' justifyContent='center' alignItems='center'>
          <CreateQuestionCardDropDownMenu handleDelete={handleDelete} />
        </Box>
      </StyledQuestionBoxHeader>
      <Box p={5.2} >
        {children}
      </Box>
    </StyledCreateQuestionBox>
  )
}

export default FollowUpWrapper
